import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import { Table } from "react-bootstrap";

const Navigator = ({toggleNavigator,setQuestionIndex,subset_id,attempt_id}) => {
  
  const [incomplete_questions, setIncompleteQuestions] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [isLoading, setLoading] = useState(true);


  const getNavigatorData = async () => {
    try {
      setLoading(true);
      const response = await ApiService.request({
          method: "GET",
          url: `getNavigatorData`,
          params: {subset_id,attempt_id},
        });
      const data = response.data;

      if (data && data.status === true) {
        setQuestions(data.data);
        setIncompleteQuestions(data.incomplete_questions);
      } else {
        toast.error(data.message || "Failed to fetch packages.");
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNavigatorData();
  }, []);

  const moveToQuestion = (index) =>{
    setQuestionIndex(index);
    toggleNavigator();
  }
  

  return (
        <div className="relative-container">
          <div className="centered-navigator">
            <div className="navigator-container">
              <div className="navigator">
                <div className="navigator-header text-white p-3 d-flex justify-content-space-between">
                  <span className="w-100">Navigator - select a question to go to it</span>
                  <span
                    className="close-icon ml-auto cursor-pointer nav-close-icon text-start"
                    onClick={toggleNavigator}
                    >   ❌ </span>
                </div>

                <div className="navigator-body h-100">
                  <Table className="table">
                    <thead>
                      <tr>
                        <th>Question #</th>
                        <th>Status</th>
                        <th>Flagged - Review</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isLoading && questions ? (
                            questions.map((question, index) => (
                              <tr key={index}>
                                <td><a href="#" onClick={() => moveToQuestion(index)} className="nav-link text-primary"> Question {index + 1} </a></td>
                                <td className={` ${question.attempt_status === 'Attempted' ? 'text-success' : 'text-danger'}`}>{question.attempt_status}</td>
                                <td>
                                  <i className={question.is_flagged ? "bi bi-flag-fill text-danger" : "bi bi-flag"}></i>
                                </td>
                              </tr>
                            ))
                        ):(
                          <tr >
                            <td colSpan={3} className="text-center text-dark my-3">
                              <span class="spinner spinner-border text-dark spinner-sm"></span> Loading...
                            </td>
                          </tr>
                         
                        )
                      }
                    </tbody>
                  </Table>
                </div>

                <footer className="navigator-footer p-2 text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="mb-0">{incomplete_questions} Unseen/Incomplete</p>
                    <button
                      className="footer-close-btn text-white"
                      onClick={toggleNavigator}
                    >
                      Close
                    </button>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
  );

};

export default Navigator;
